import tw, { styled } from 'twin.macro';

import { motion } from '@ubisend/framer-motion';

const NotificationContainer = styled(motion.div)`
  ${tw`overflow-y-auto overflow-x-hidden h-full bg-white`};
`;

export default NotificationContainer;
